var moduleMap = {
	"./Curation": function() {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_apollo_client_apollo_client-src_index_pcss-src_index_pcss-src-69900b"), __webpack_require__.e("src_components_atom_TailwindZoneWrapper_tsx-src_components_template_CurationTemplate_tsx-src_-d50c56"), __webpack_require__.e("src_standalone_Curation_tsx")]).then(function() { return function() { return (__webpack_require__(1893)); }; });
	},
	"./PremiumCourse": function() {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_apollo_client_apollo_client-src_index_pcss-src_index_pcss-src-69900b"), __webpack_require__.e("src_standalone_PremiumCourse_tsx")]).then(function() { return function() { return (__webpack_require__(6581)); }; });
	},
	"./EssentialCourse": function() {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_apollo_client_apollo_client-src_index_pcss-src_index_pcss-src-69900b"), __webpack_require__.e("webpack_sharing_consume_default_zustand_zustand"), __webpack_require__.e("src_standalone_EssentialCourse_tsx")]).then(function() { return function() { return (__webpack_require__(6029)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});